import styled from 'styled-components'
import { mq } from '../../styles/vars/media-queries.style'

export const TableWrapper = styled.div`
  max-width: 100%;
  overflow: scroll;
  padding-bottom: 2rem;

  ${mq.tabletL} {
    max-width: auto;
    overflow: visible;
  }
`

export const TableRow = styled.tr``

export const TableData = styled.td`
  padding: 1rem;
  border: 1px solid black;
  white-space: nowrap;

  ${mq.tabletL} {
    white-space: normal;
  }
`
export const Table = styled.table`
  border-collapse: collapse;
  min-width: 100%;
`

export const TableHead = styled.thead`
  ${TableData} {
    font-weight: 500;
  }
`
export const TableBody = styled.tbody``
